var React = require('react');

function More24px (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.1665 8.00033C7.1665 8.73673 7.76344 9.33366 8.49984 9.33366C9.23624 9.33366 9.83317 8.73673 9.83317 8.00033C9.83317 7.26393 9.23624 6.66699 8.49984 6.66699C7.76344 6.66699 7.1665 7.26393 7.1665 8.00033Z","fill":"#FCF8F3","key":0}),React.createElement("path",{"d":"M7.1665 12.6663C7.1665 13.4027 7.76344 13.9997 8.49984 13.9997C9.23624 13.9997 9.83317 13.4027 9.83317 12.6663C9.83317 11.9299 9.23624 11.333 8.49984 11.333C7.76344 11.333 7.1665 11.9299 7.1665 12.6663Z","fill":"#FCF8F3","key":1}),React.createElement("path",{"d":"M7.1665 3.33333C7.1665 4.06971 7.76344 4.66667 8.49984 4.66667C9.23624 4.66667 9.83317 4.06971 9.83317 3.33333C9.83317 2.59695 9.23624 2 8.49984 2C7.76344 2 7.1665 2.59695 7.1665 3.33333Z","fill":"#FCF8F3","key":2})]);
}

More24px.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = More24px;

More24px.default = More24px;
